module.exports = __webpack_public_path__ + "static/media/Pattern_VTB-03.90360e49.png";